import { jsx as y } from "react/jsx-runtime";
import { n as b } from "./emotion-styled.browser.esm.js";
import { isPureObject as x } from "../utils/misc/index.js";
import "../theme/index.js";
import "react";
import "./_baseGetTag.js";
import { lightenColor as c } from "../utils/color/index.js";
import { useTheme as w } from "../theme/hooks/index.js";
const R = (i, o) => {
  switch (i) {
    case "error":
      return {
        color: o.colors.error
      };
    case "warning":
      return {
        color: o.colors.yellow[600],
        backgroundColor: c(o.colors.warning, 90)
      };
    case "info":
      return {
        color: o.colors.info
      };
    case "success":
      return {
        color: o.colors.success
      };
    default:
    case "neutral":
      return {
        color: o.colors.gray[600]
      };
  }
}, C = ({ size: i, variant: o }, s) => {
  switch (i) {
    case "xs": {
      const r = `
        font-size: ${s.fontSize.xs[0]};
        line-height: ${s.fontSize.xs[1].lineHeight};
        gap: ${s.gap[1]};
      `;
      return o === "solid" ? `
          ${r}
          padding: ${s.spacing[0.5]} ${s.spacing[2]};
          border-radius: ${s.borderRadius.xl};
        ` : r;
    }
    case "sm": {
      const r = `
        font-size: ${s.fontSize.sm[0]};
        line-height: ${s.fontSize.sm[1].lineHeight};
        gap: ${s.gap[1.5]};
      `;
      return o === "solid" ? `
          ${r}
          padding: ${s.spacing[1]} ${s.spacing[3]};
          border-radius: ${s.borderRadius["2xl"]};
        ` : r;
    }
    case "lg": {
      const r = `
        font-size: ${s.fontSize.lg[0]};
        line-height: ${s.fontSize.lg[1].lineHeight};
        gap: ${s.gap[2.5]};
      `;
      return o === "solid" ? `
          ${r}
          padding: ${s.spacing[1.5]} ${s.spacing[5]};
          border-radius: ${s.borderRadius["3xl"]};
        ` : r;
    }
    default:
    case "md": {
      const r = `
        font-size: ${s.fontSize.base[0]};
        line-height: ${s.fontSize.base[1].lineHeight};
        gap: ${s.gap[2]};
      `;
      return o === "solid" ? `
          ${r}
          padding: ${s.spacing[1]} ${s.spacing[4]};
          border-radius: ${s.borderRadius["2xl"]};
        ` : r;
    }
  }
}, H = b.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${({ size: i, variant: o, theme: s }) => C({ size: i, variant: o }, s)};
`, D = ({
  appearance: i = "neutral",
  icon: o,
  label: s,
  children: r,
  style: a,
  size: d = "md",
  variant: e = "solid",
  ...g
}) => {
  const p = w(), { position: u, icon: n } = x(o) ? { ...o, position: o.position ?? "start" } : { position: "start", icon: o }, t = [r ?? s], f = R(i, p), { color: l, backgroundColor: $, ...S } = {
    ...f,
    ...a
  }, z = {
    color: l,
    backgroundColor: e === "solid" ? $ ?? c(l, 90) : "transparent",
    ...S
  };
  return n && (u === "start" ? t.unshift(n) : t.push(n)), /* @__PURE__ */ y(H, { style: z, size: d, variant: e, ...g, children: t });
};
export {
  D as S
};
